import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NavItem } from '../../models/nav-items';
import { MediaMatcher } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/AuthService/auth.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import {
  AccessTokenResCustomerInfo,
  LoginResponse,
} from '../../services/models/responses/login-response-model';
import { title } from 'process';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { StorageKey } from '../../services/storage/storage-model';
import { SessionStorageService } from '../../services/storage/session-storage.service';
import { ProgressSpinnerService } from '../../services/progress-spinner.service';
import { NavigationExtras, Router } from '@angular/router';
import { WhiteLabelJsonService } from '../../services/white-label-json.service';
import { UserRightsService } from '../../services/user-rights.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  AuthApiGeneratedService,
  RefreshTokenReq,
} from '../../services/AuthService/auth-service-generate';
import { MatDialog } from '@angular/material/dialog';
import {
  AdminGeneratedService,
  Condition,
  RequestFilter,
  UserDTO,
  UsersReq,
  UsersRes,
} from '../../services/AdminService/admin-service-generate';
import { environment } from 'src/environments/environment';
import { FastTransactionDialogComponent } from '../modals/fast-transaction-dialog/fast-transaction-dialog.component';
import { debug } from 'console';
const { SELECTED_CUSTOMER_IDENTITY, SELECTED_CUSTOMER_TITLE, AUTH_TOKEN } =
  StorageKey;
// tslint:disable-next-line: typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})
export class SidenavComponent implements OnDestroy, OnInit {
  @ViewChild('userInfoDialog', { static: true })
  userInfoDialog: TemplateRef<any>;
  fixedMenu = false;
  userName: string;
  isDespatch = false;
  isInvoice = true;
  isEArchive = true;
  isAdmin = true;
  isLoggedIn: boolean;
  sidenavWidth = 6;
  sysAdminVkn = null;
  isSystemAdmin: boolean;
  miniToolbarLogo = null;
  sidenavChildWidth = 7;
  ngStyle: string;
  slideChecked = false;
  requestFilter: RequestFilter[] = [];
  userInfoRes: UserDTO;
  defaultCustomerForSlideToggle = false;
  otherTheme: boolean = false;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private authServiceCodegen: AuthApiGeneratedService,
    media: MediaMatcher,
    private authService: AuthService,
    private translateService: TranslateService,
    // tslint:disable-next-line: max-line-length
    private localStorageService: LocalStorageService,
    private sessionStoraService: SessionStorageService,
    private snipper: ProgressSpinnerService,
    private router: Router,
    private whiteLabelService: WhiteLabelJsonService,
    private userRightsService: UserRightsService,
    private dialog: MatDialog,
    private adminGenerateService: AdminGeneratedService,
  ) {
    this.isLoggedIn = false;
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.sysAdminVkn = environment.sysAdminVKN;
  }

  ngOnInit(): void {
    this.userName = this.authService.getUserName();
    if (this.localStorageService.read(SELECTED_CUSTOMER_IDENTITY) === null) {
      this.value = this.authService.getSelectedCompanyIdentity().toString();
    } else {
      this.value = this.localStorageService.read(SELECTED_CUSTOMER_IDENTITY);
      this.defaultCustomerForSlideToggle = true;
    }
    this.changeCustomerIdentity = this.value;
    this.changeCustomerTitle = this.authService.getSelectedCompanyTitle();
    // this.defaultCustomerForSlideToggle = false;
    this.customerChangeData = [];
    this.customerChangeData.push({
      Identity: this.authService.getSelectedCompanyIdentity(),
      Title: this.authService.getSelectedCompanyTitle(),
    });
    const arr = this.authService.getCompanyInfo();
    arr.forEach((x, y) => {
      if (x.identity === this.authService.getSelectedCompanyIdentity()) {
        arr.splice(y, 1);
      }
    });
    arr.forEach((element) => {
      this.customerChangeData.push({
        Identity: element.identity.toString(),
        Title: element.title.toString(),
      });
    });
    this.reloadLanguage(localStorage.getItem('lang'));
  }

  isLoggedIn$: Observable<boolean>;
  isExpanded = true;
  permissionList = null;
  changeCustomerIdentity = null;
  changeCustomerTitle = null;
  companyOrganizationPanelOpen = false;
  partnerOrganizationPanelOpen = false;
  userOrganizationPanelOpen = false;
  serviceActivisionOrganizationPanelOpen = false;
  agreementOrganizationPanelOpen = false;
  contourOrganizationPanelOpen = false;
  parameterOrganizationPanelOpen = false;
  systemOrganizationPanelOpen = false;
  accountingOrganizationPanelOpen = false;
  reportPanelOpen = false;
  isShowing = false;
  public value = 'Erdem';
  public fields = { text: 'Title', value: 'Identity' };
  customerChangeData: Object[] = [];
  partnerOrganizationMenu: NavItem[] = [];
  companyOrganizationMenu: NavItem[] = [];
  parameterOrganizationMenu: NavItem[] = [];
  userOrganizationMenu: NavItem[] = [];
  agreementOrganizationMenu: NavItem[] = [];
  systemOrganizationMenu: NavItem[] = [];
  contourOrganizationMenu: NavItem[] = [];
  serviceActivisionOrganizationMenu: NavItem[] = [];
  accountingOrganizationMenu: NavItem[] = [];
  servicesOrganizationMenu: NavItem[] = [];
  reportMenu: NavItem[] = [];

  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  mouseenter() {
    //eski deger 15 ti
    this.sidenavWidth = 20;
    this.sidenavChildWidth = 20;
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.fixedMenu) {
      this.sidenavWidth = 6;
      this.sidenavChildWidth = 10;
      if (!this.isExpanded) {
        this.isShowing = false;
      }
    }
  }

  fastTransactions() {
    let dialogRef = this.dialog.open(FastTransactionDialogComponent, {
      disableClose: true,
      width: 'auto',
      height: 'auto',
      position: { top: '20px' },
    });
  }

  // tslint:disable-next-line: typedef
  customerChange(e) {
    console.log(e.itemData);
    console.log(this.value);
    this.sessionStoraService.save(
      SELECTED_CUSTOMER_IDENTITY,
      e.itemData.Identity,
    );
    this.sessionStoraService.save(SELECTED_CUSTOMER_TITLE, e.itemData.Title);
    this.changeCustomerIdentity = e.itemData.Identity;
    this.changeCustomerTitle = e.itemData.Title;
    if (
      this.localStorageService.read(SELECTED_CUSTOMER_IDENTITY) ===
      e.itemData.Identity
    ) {
      this.defaultCustomerForSlideToggle = true;
    } else {
      this.defaultCustomerForSlideToggle = false;
    }

    this.customerChangeFunc(e.itemData.Identity);
    console.log(this.defaultCustomerForSlideToggle);
  }

  customerChangeFunc(customerIdentity) {
    setTimeout(() => this.snipper.show(), 0);
    const accessToken = this.sessionStoraService.read(AUTH_TOKEN);
    this.authService.changeCustomer(accessToken, customerIdentity).subscribe(
      (response) => {
        setTimeout(() => {
          if (response.isSuccessed) {
            this.authService
              .initialise(response, null, 'portal/dashboard', customerIdentity)
              .then((res) => {
                this.allMenuPanelClosed();
                this.getAllMenu();

                const objToSend: NavigationExtras = {
                  queryParams: {
                    customerChange: true,
                  },

                  skipLocationChange: true,
                  fragment: 'top',
                };

                this.router.navigate(['portal/customerchange'], {
                  state: { dashboardPageObject: objToSend },
                });

                this.snipper.hide();
              });
          }
        }, 600);
      },
      (err) => {
        this.snipper.hide();
        this.router.navigateByUrl('login');
      },
    );
  }

  async ngAfterViewInit() {
    this.miniToolbarLogo =
      await this.whiteLabelService.getKeyJsonParameter('mini-logo-toolbar');
    this.getAllMenu();
  }

  // tslint:disable-next-line: typedef
  getAllMenu() {
    setTimeout(() => this.snipper.show(), 0);
    setTimeout(() => {
      this.AllMenuList();
      this.snipper.hide();
    }, 600);
  }

  // tslint:disable-next-line: typedef
  AllMenuList() {
    if (
      this.sysAdminVkn ===
      JSON.parse(sessionStorage.getItem('SELECTED_CUSTOMER_IDENTITY'))
    ) {
      this.isSystemAdmin = true;
    } else {
      this.isSystemAdmin = false;
    }

    this.contourOrganizationMenu = [
      {
        displayName: 'SIDENAV.CONTOUR_OPERATIONS',
        iconName: 'credit_card',
        children: [
          {
            displayName: 'SIDENAV.PARTNER_CONTOUR_LIST',
            iconName: 'list_alt',
            route: 'partnerContourList',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Contours_List_PartnerContourDocuments',
            ),
          },
          {
            displayName: 'SIDENAV.CUSTOMER_CONTOUR_LIST',
            iconName: 'list_alt',
            route: 'customerContourList',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Contours_List_CustomerContourDocuments',
            ),
          },
        ],
      },
    ];

    this.serviceActivisionOrganizationMenu = [
      {
        displayName: 'SIDENAV.SERVICE_ACTIVISION_OPERATIONS',
        iconName: 'add_task',
        children: [
          {
            displayName: 'SIDENAV.CUSTOMER_ACTIVISIONS_LIST',
            iconName: 'list_alt',
            route: 'customerActivisionList',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Activations_List_Activations',
            ),
          },
          {
            displayName: 'SIDENAV.PARTNER_ROUTE_TENANT_LIST',
            iconName: 'list_alt',
            route: 'partnerRouteTenantList',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'PartnerRouteTenants_List_RouteTenants',
            ),
          },
        ],
      },
    ];

    this.systemOrganizationMenu = [
      {
        displayName: 'SIDENAV.SYSTEM_SETTINGS',
        iconName: 'settings',
        children: [
          {
            displayName: 'SIDENAV.PREFIX_MANAGEMENT_PARENT_MENU',
            iconName: 'ballot',
            route: 'documentPrefix',
            children: [
              {
                displayName: 'SIDENAV.PREFIX_MANAGEMENT',
                iconName: 'pin',
                route: 'documentPrefix',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'DocumentPrefix_List_DocumentPrefix',
                  ),
              },
              {
                displayName: 'SIDENAV.IMAGE_MANAGEMENT',
                iconName: 'image_search',
                route: 'documentXslt',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'XsltDocument_List_XsltDocument',
                  ),
              },
              {
                displayName: 'SIDENAV.MAPPING_MANAGEMENT',
                iconName: 'mediation',
                route: 'documentMapping',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'DocumentMapping_List_DocumentMapping',
                  ),
              },
            ],
          },

          {
            displayName: 'SIDENAV.SYSTEM_CONTROL',
            iconName: 'build',
            route: 'systemControl',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'SystemDocumentFlow_GibConnectorList',
              ) && this.isSystemAdmin,
            children: [
              {
                displayName: 'SIDENAV.SYSTEM_CONTROL_TRACE',
                iconName: 'trending_up',
                route: 'systemControl',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'SystemDocumentFlow_GibConnectorList',
                  ) && this.isSystemAdmin,
              },
            ],
          },

          {
            displayName: 'SIDENAV.APP_DEFINITION',
            iconName: 'display_settings',
            route: 'additionalField',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'OutgoingAdditionalFields_List_Fields',
              ) && this.isSystemAdmin,
            children: [
              {
                displayName: 'SIDENAV.RULE_DEFINITION',
                iconName: 'dashboard_customize',
                route: 'ruleDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'Rules_List_RuleDefinitions',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.CUSTOMER_RULE_DEFINITION',
                iconName: 'dashboard_customize',
                route: 'customerRuleDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'Rules_List_CustomerRules',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.ADDITIONAL_FIELD',
                iconName: 'dashboard_customize',
                route: 'additionalField',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'OutgoingAdditionalFields_List_Fields',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.IP_FILTER_EXPRESSION',
                iconName: 'filter_alt',
                route: 'ipFilterManagement',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'CustomerAllowedIP_List_Filters',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.CUSTOMER_FTP_DEFINITION',
                iconName: 'list_alt',
                route: 'customerFtpDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'CustomerSftpInfoDefin_List_Ftp',
                  ) && this.isSystemAdmin,
              },
            ],
          },

          {
            displayName: 'SIDENAV.ELEDGER_ARCHIVE_DEFINITION',
            iconName: 'book',
            route: 'eledgerArchiveServerDefinition',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'ELedgerGibAppServer_List_Servers',
              ) && this.isSystemAdmin,
            children: [
              {
                displayName: 'SIDENAV.ELEDGER_ARCHIVE_SERVER_DEFINITION',
                iconName: 'reset_tv',
                route: 'eledgerArchiveServerDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'ELedgerGibAppServer_List_Servers',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.CUSTOMER_SERVER_DEFINITIONS',
                iconName: 'reset_tv',
                route: 'eledgerArchiveCustomerServer',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'ELedgerGibAppServer_List_CustomerServers',
                  ) && this.isSystemAdmin,
              },
            ],
          },
          {
            displayName: 'SIDENAV.API_LOCALIZATION',
            iconName: 'book',
            route: 'apiPathDefinition',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'ApiLocalization_List_Paths',
              ) && this.isSystemAdmin,
            children: [
              {
                displayName: 'SIDENAV.API_PATH_DEFINITION',
                iconName: 'reset_tv',
                route: 'apiPathDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'ApiLocalization_List_Paths',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.CUSTOMER_API_LANGUAGE',
                iconName: 'reset_tv',
                route: 'customerApiLanguage',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'ApiLocalization_List_CustomerLanguages',
                  ) && this.isSystemAdmin,
              },
              {
                displayName: 'SIDENAV.API_TEXT_DEFINITION',
                iconName: 'reset_tv',
                route: 'apiTextDefinition',
                isPermisson:
                  this.userRightsService.getUserRightsIsEnabledWithKey(
                    'ApiLocalization_List_ApiTextValue',
                  ) && this.isSystemAdmin,
              },
            ],
          },
          // {
          //   displayName: 'SIDENAV.PARTNER_AGREEMENT_LIST',
          //   iconName: 'list_alt',
          //   route: 'partnerAgreements',
          //   isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
          //     'Agreements_List_PartnerAgreements'
          //   ),
          // },
          // {
          //   displayName: 'SIDENAV.CUSTOMER_AGREEMENT_LIST',
          //   iconName: 'list_alt',
          //   route: 'customerAgreements',
          //   isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
          //     'Agreements_List_CustomerAgreements'
          //   ),
          // },
        ],
      },
    ];

    this.agreementOrganizationMenu = [
      {
        displayName: 'SIDENAV.AGREEMENTS',
        iconName: 'assignment',
        children: [
          {
            displayName: 'SIDENAV.AGREEMENT_SERVICE_COEF',
            iconName: 'list_alt',
            route: 'agreementServiceCoefficient',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'Agreements_List_AgreementServiceCoef',
              ) && this.isSystemAdmin,
          },
          {
            displayName: 'SIDENAV.PARTNER_AGREEMENT_LIST',
            iconName: 'list_alt',
            route: 'partnerAgreements',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'Agreements_List_PartnerAgreements',
              ) && this.isSystemAdmin,
          },
          {
            displayName: 'SIDENAV.CUSTOMER_AGREEMENT_LIST',
            iconName: 'list_alt',
            route: 'customerAgreements',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Agreements_List_CustomerAgreements',
            ),
          },
        ],
      },
    ];

    this.userOrganizationMenu = [
      {
        displayName: 'SIDENAV.USERS',
        iconName: 'manage_accounts',
        children: [
          {
            displayName: 'SIDENAV.USER_LIST',
            iconName: 'list_alt',
            route: 'userlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'PartnerUser_List_Users',
            ),
          },
          {
            displayName: 'SIDENAV.CUSTOMER_BRANCH_USER_LIST',
            iconName: 'list_alt',
            route: 'customerBranchUserlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'CustomerBranchUsers_List_BranchUsers',
            ),
          },
          {
            displayName: 'SIDENAV.ROLE_LIST',
            iconName: 'list_alt',
            route: 'rolelist',
            isPermisson:
              this.userRightsService.getUserRightsIsEnabledWithKey(
                'Role_List_Roles',
              ),
          },
        ],
      },
    ];

    this.partnerOrganizationMenu = [
      {
        displayName: 'SIDENAV.PARTNERS',
        iconName: 'account_balance',
        children: [
          {
            displayName: 'SIDENAV.PARTNER_LIST',
            iconName: 'list_alt',
            route: 'partnerlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Partner_List_Partners',
            ),
          },
        ],
      },
    ];
    this.companyOrganizationMenu = [
      {
        displayName: 'SIDENAV.CUSTOMERS',
        iconName: 'business',
        children: [
          {
            displayName: 'SIDENAV.CUSTOMER_LIST',
            iconName: 'list_alt',
            route: 'customerlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Customer_List_Customers',
            ),
          },
          {
            displayName: 'SIDENAV.CUSTOMER_BRANCH_LIST',
            iconName: 'list_alt',
            route: 'customerBranchlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'CustomerBranch_List_Branch',
            ),
          },
        ],
      },
    ];
    this.parameterOrganizationMenu = [
      {
        displayName: 'SIDENAV.PARAMETERS',
        iconName: 'tune',
        children: [
          {
            displayName: 'SIDENAV.PARAMETER_LIST',
            iconName: 'list_alt',
            route: 'parameterlist',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'AppPrm_List_Parameters',
            ),
          },
        ],
      },
    ];

    this.reportMenu = [
      {
        displayName: 'SIDENAV.REPORTS',
        iconName: 'tune',
        children: [
          {
            displayName: 'SIDENAV.LEDGER_ARCHIVE_REPORT',
            iconName: 'list_alt',
            route: 'ledgerArchiveReport',
            isPermisson: this.userRightsService.getUserRightsIsEnabledWithKey(
              'Partner_Get_Ledger_Archive_Report',
            ),
          },
        ],
      },
    ];
  }

  slideToggleChange(e) {
    console.log(e.checked);
    this.slideChecked = e.checked;
    if (e.checked) {
      this.localStorageService.save(
        SELECTED_CUSTOMER_IDENTITY,
        this.changeCustomerIdentity,
      );
      this.localStorageService.save(
        SELECTED_CUSTOMER_TITLE,
        this.changeCustomerTitle,
      );
      this.defaultCustomerForSlideToggle = true;
    } else {
      this.localStorageService.remove(SELECTED_CUSTOMER_IDENTITY);
      this.localStorageService.remove(SELECTED_CUSTOMER_TITLE);
      this.defaultCustomerForSlideToggle = false;
    }
  }

  reloadLanguage(language: string) {
    this.translateService.use(language);
    this.translateService.setDefaultLang(language);
  }

  allMenuPanelClosed() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickUserOrganization() {
    this.companyOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickServiceActivisionOrganization() {
    this.companyOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.userOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickCompanyOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickAgreementOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickContourOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickPartnerOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickParameterOrganization() {
    this.companyOrganizationPanelOpen = false;
    this.userOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickAccountingOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickSystemOrganization() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.reportPanelOpen = false;
  }

  panelClickReport() {
    this.userOrganizationPanelOpen = false;
    this.parameterOrganizationPanelOpen = false;
    this.companyOrganizationPanelOpen = false;
    this.accountingOrganizationPanelOpen = false;
    this.partnerOrganizationPanelOpen = false;
    this.agreementOrganizationPanelOpen = false;
    this.serviceActivisionOrganizationPanelOpen = false;
    this.contourOrganizationPanelOpen = false;
    this.systemOrganizationPanelOpen = false;
  }

  changePassword() {
    this.router.navigateByUrl('/passwordreset');
  }

  userInfo() {
    const filteringObject = new RequestFilter();
    filteringObject.name = 'email';
    filteringObject.condition = Condition.Contains;
    filteringObject.value = JSON.parse(localStorage.getItem('USER_EMAIL'));
    this.requestFilter.push(filteringObject);
    const usersReq = new UsersReq();
    usersReq.filters = this.requestFilter;
    this.adminGenerateService.users(usersReq).subscribe((res) => {
      console.log(res, 'UserInfo');
      this.userInfoRes = res.users[0];
      this.dialog.open(this.userInfoDialog, {
        disableClose: true,
        maxWidth: '400px',
      });
    });
  }

  fixedMenuChange(event) {
    this.fixedMenu = event.checked;

    if (event.checked) {
      this.sidenavWidth = 20;
      this.sidenavChildWidth = 20;
      if (!this.isExpanded) {
        this.isShowing = true;
      }
    } else {
      this.sidenavWidth = 6;
      this.sidenavChildWidth = 10;
      if (!this.isExpanded) {
        this.isShowing = false;
      }
    }
  }

  onLogout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  changeTheme(): void {
    this.otherTheme = !this.otherTheme;
  }
}
